import { render, staticRenderFns } from "./BaseColorField.vue?vue&type=template&id=f40d9db8&"
import script from "./BaseColorField.vue?vue&type=script&lang=js&"
export * from "./BaseColorField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports